const publisher_accounts = [
  "Publisher Name",
  "Phone",
  "Requested for",
  "Actions",
];

const author_accounts = ["Author Name", "Phone", "Requested for", "Actions"];

const user_accounts = ["Name", "Phone", "Requested for", "Actions"];

const school_accounts = [
  "Managed by",
  "School Name",
  "Phone",
  "Requested for",
  "Actions",
];

const deactivated_accounts = [
  "Name",
  "Phone",
  "Role",
  "Joined Date",
  "Status",
  "Actions",
];

const headers_enums = {
  publisher_accounts: 0,
  author_accounts: 1,
  school_accounts: 2,
  reader_accounts: 3,
  parent_accounts: 4,
  deactivated_accounts: 5,
};

export {
  publisher_accounts,
  author_accounts,
  school_accounts,
  deactivated_accounts,
  headers_enums,
  user_accounts,
};
